//获取数据方法

//获取导航信息
export const getNavInfo = function (state) {
  return state.navInfo;
};

//获取用户信息
export const getUserInfo = function (state) {
  return state.userInfo;
};

//获取最高权限id
export const getRootUserInfo = function (state) {
  return state.rootId;
};
//获取消息红点
export const getShowhidden = function (state) {
  return state.showhidden;
};
//获取会员状态
export const getMemberInfo = function (state) {
  return state.memberInfo || {};
};
